import React, { useEffect, useRef } from 'react';
import CustomTextField from '../../../../shared/form-controls/custom-text-field/Custom-Text-Field';
import CustomSelect from '../../../../shared/form-controls/custom-select/Custom-Select';
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  Radio,
  RadioGroup,
} from '@material-ui/core';
import KeyValuePairList from '../../../../shared/key-value-pair-list/KeyValuePairList';
import { useDispatch, useSelector } from 'react-redux';
import { allActivityCalendarCategoriesSelector, fetchActivityTagsList } from '../../cmsSlice';
import CustomMultiSelectCrud from '../../../../shared/form-controls/custom-multi-select-crud/CustomMultiSelectCrud';
import {
  createActivity,
  deleteActivity,
  updateActivity,
} from '../../../../utils/activityCalendarAPIUtils';
import { notificationManager } from '../../../../utils/NotificationUtils';
import { SELECT_ICON } from '../../../../constants/ActivityCalendarConst';
import { stepDownLoaderCount, stepUpLoaderCount } from '../../../../utils/loaderSlice';
import CustomMultiSelect from '../../../../shared/form-controls/custom-multi-select/Custom-Multi-Select';
import Tooltip from '@mui/material/Tooltip';
import InfoIcon from '@mui/icons-material/Info';
import { withStyles } from '@material-ui/core/styles';

const CustomToolTip = withStyles({
  tooltip: { color: 'white', backgroundColor: 'black' },
})(Tooltip);

const GENDER_OPTIONS = [
  { id: 'Male', name: 'Male' },
  { id: 'Female', name: 'Female' },
  { id: 'Other', name: 'Other' },
];

const Details = ({ initialValue, handleOnChange, language, showLoader = () => {} }) => {
  const dispatch = useDispatch();
  let hotelId = useSelector(({ property }) => property?.selectedHotel);
  const activityType = useSelector(({ cms }) => cms?.activityTagsList);
  const activityCategories = useSelector(allActivityCalendarCategoriesSelector);
  const deletingIdsRef = useRef(new Set());

  const handleGetTagsList = async () => {
    await dispatch(fetchActivityTagsList(hotelId));
  };
  const handleCreate = async (value) => {
    try {
      dispatch(stepUpLoaderCount());
      let res = await createActivity(hotelId, value, language);
      if (res?.data?.createActivityTag?.status) {
        notificationManager('success', res?.data?.createActivityTag?.message);
        handleGetTagsList();
      }
    } catch (error) {
      if (error?.graphQLErrors) {
        notificationManager('danger', error?.graphQLErrors?.[0]?.message);
      } else {
        notificationManager('danger', `Failed to create tag`);
      }
    } finally {
      dispatch(stepDownLoaderCount());
    }
  };

  const handleEditTag = async (value, id) => {
    try {
      dispatch(stepUpLoaderCount());
      let res = await updateActivity(hotelId, value, id, language);
      if (res?.data?.updateActivityTag?.id) {
        notificationManager('success', 'Activity tag updated successfully');
        handleGetTagsList();
      }
    } catch (error) {
      if (error?.graphQLErrors) {
        notificationManager('danger', error?.graphQLErrors?.[0]?.message);
      } else {
        notificationManager('danger', `Failed to update tag`);
      }
    } finally {
      dispatch(stepDownLoaderCount());
    }
  };

  const handleDeleteTag = async (id) => {
    if (deletingIdsRef?.current?.has(id)) return;
    deletingIdsRef?.current?.add(id);
    try {
      dispatch(stepUpLoaderCount());
      let res = await deleteActivity(hotelId, id, language);
      if (res?.data?.deleteActivityTag?.status) {
        notificationManager('success', res?.data?.deleteActivityTag?.message);
        handleGetTagsList();
      }
    } catch (error) {
      if (error?.graphQLErrors) {
        notificationManager('danger', error?.graphQLErrors?.[0]?.message);
      } else {
        notificationManager('danger', `Failed to delete tag`);
      }
    } finally {
      dispatch(stepDownLoaderCount());
    }
  };

  useEffect(() => {
    handleGetTagsList();
  }, []);

  useEffect(() => {
    let activityTagIds = activityType?.map((tag) => tag?.id);
    let selectedtag = initialValue?.tag?.value?.filter((selectedTag) =>
      activityTagIds?.includes(selectedTag?.id),
    );
    handleOnChange({
      tag: {
        ...initialValue?.tag,
        value: selectedtag,
        errors: {},
      },
    });
  }, [activityType]);

  useEffect(() => {
    const activeIds = new Set(
      (activityCategories || [])?.filter((c) => c?.isActive === true)?.map((c) => c?.id),
    );

    const selectedId = initialValue?.category?.value;
    if (selectedId && !activeIds?.has(selectedId)) {
      handleOnChange({
        category: {
          ...initialValue?.category,
          value: '',
          errors: {},
        },
      });
    }
  }, [activityCategories]);

  useEffect(() => {
    const activeIds = new Set(
      (activityCategories || [])?.filter((c) => c?.isActive === true)?.map((c) => c?.id),
    );

    const selectedId = initialValue?.category?.value;
    if (selectedId && !activeIds?.has(selectedId)) {
      handleOnChange({
        category: {
          ...initialValue?.category,
          value: '',
          errors: {},
        },
      });
    }
  }, [activityCategories]);

  const toIds = (arr) =>
    Array.isArray(arr) ? arr.map((x) => (typeof x === 'string' ? x : x?.id)).filter(Boolean) : [];

  return (
    <>
      <div className='row'>
        <div className='col-md-6 mb-3'>
          <CustomSelect
            valueField='id'
            labelField='name'
            item={initialValue?.category}
            handleInputChange={(e) => {
              handleOnChange({ category: e });
            }}
            options={activityCategories?.filter((category) => category?.isActive === true)}
            hideNullOption={true}
          />
        </div>
        <div className='col-md-6 mb-3'>
          <CustomTextField
            item={initialValue.name}
            handleInputChange={(e) => {
              handleOnChange({ name: e });
            }}
            maxLength={100}
            endAdornment={true}
            characterCount={true}
            multiline={true}
          />
        </div>
      </div>
      <div className='row'>
        <div className='col-md-6 mb-3'>
          <CustomMultiSelectCrud
            item={initialValue?.tag}
            options={activityType}
            handleCreate={handleCreate}
            handleEditTag={handleEditTag}
            handleDeleteTag={handleDeleteTag}
            classNameProps={'ellipsisText'}
            handleInputChange={(value) =>
              handleOnChange({
                tag: {
                  ...initialValue?.tag,
                  value,
                  errors: {},
                },
              })
            }
          />
        </div>
        <div className='col-md-6 mb-3'>
          <CustomTextField
            type='number'
            item={initialValue?.price}
            handleInputChange={(e) => {
              handleOnChange({ price: e });
            }}
            min={0}
            max={99999999}
          />
        </div>
      </div>
      <div className='row'>
        <div className='col-md-12 mb-3'>
          <CustomTextField
            item={initialValue.description}
            handleInputChange={(e) => {
              handleOnChange({ description: e });
            }}
            multiline={true}
            maxLength={350}
            endAdornment={true}
            characterCount={true}
          />
        </div>
      </div>
      <div className='row'>
        <div className='col-md-12 mb-3'>
          <CustomTextField
            item={initialValue.highlights}
            handleInputChange={(e) => {
              handleOnChange({ highlights: e });
            }}
            multiline={true}
            maxLength={350}
            endAdornment={true}
            characterCount={true}
          />
        </div>
      </div>
      <div className='row'>
        <div className='col-md-6 mb-3'>
          <CustomTextField
            type='number'
            item={initialValue?.capacity}
            handleInputChange={(e) => {
              handleOnChange({ capacity: e });
            }}
            min={0}
            max={99999999}
            step={1}
            stripZeroOnSpinner
          />
        </div>
        <div className='col-md-6 mb-3'>
          <CustomMultiSelect
            item={{
              ...initialValue?.selectIcons,
              value: toIds(initialValue?.selectIcons?.value),
              fieldName: initialValue?.selectIcons?.fieldName || 'Select Icons',
            }}
            options={SELECT_ICON}
            labelField='name'
            valueField='id'
            placeholder='Select Icons'
            classNameProps='ellipsisText'
            isCustomDisplay
            renderCustomDisplay={(selected) => {
              const matched = selected
                ?.map((id) => SELECT_ICON?.find((ic) => ic?.id === id))
                ?.filter(Boolean);
              const MAX_VISIBLE = 3;
              const visible = matched?.slice(0, MAX_VISIBLE);
              const remaining = matched?.length > MAX_VISIBLE ? matched?.length - MAX_VISIBLE : 0;
              return (
                <span style={{ display: 'flex', alignItems: 'center', width: '100%', position: 'relative', overflow: 'hidden', whiteSpace: 'nowrap' }}>
                  <span style={{ display: 'inline-flex', alignItems: 'center', minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', marginRight: remaining > 0 ? 70 : 0 }}>
                    {visible?.map((ic, idx) => (
                      <span key={ic?.id} style={{ display: 'inline-flex', alignItems: 'center', flexShrink: 0 }}>
                        <img src={ic?.url} alt={ic?.name} width='16' height='16' style={{ marginRight: 4 }} />
                        {ic?.name}{idx < visible.length - 1 ? ',\u00A0' : ''}
                      </span>
                    ))}
                  </span>
                  {remaining > 0 && (
                    <span style={{ position: 'absolute', right: 0, color: '#03E67C', fontWeight: 600, fontSize: '13px', background: '#fff', paddingLeft: 4 }}>
                      +{remaining} more
                    </span>
                  )}
                </span>
              );
            }}
            renderOptionLabel={(item) => (
              <span style={{ display: 'flex', alignItems: 'center' }}>
                <img src={item?.url} alt={item?.name} width='20' height='20' style={{ marginRight: 8 }} />
                {item?.name}
              </span>
            )}
            handleInputChange={(selectedField) => {
              handleOnChange({
                selectIcons: { ...initialValue?.selectIcons, value: selectedField.value, errors: {} },
              });
            }}
          />
        </div>
      </div>
      <div className='row'>
        <div className='col-md-5'>
          <div className='d-flex align-items-center mb-3'>
            <FormGroup>
              <FormControlLabel
                control={
                  <Checkbox
                    className='check-box'
                    checked={initialValue?.active?.value}
                    onChange={() => {
                      handleOnChange({
                        active: {
                          ...initialValue?.active,
                          value: !initialValue?.active?.value,
                        },
                      });
                    }}
                  />
                }
                label='Active'
              />
            </FormGroup>
          </div>
        </div>
      </div>
      <div className='row mt-2'>
        <div className='col-md-12'>
          <h4 className='tab-title'>Participant Requirements</h4>
        </div>
        <div className='col-md-5'>
          <div className='d-flex align-items-center mt-1 ' onClick={(e) => e.stopPropagation()}>
            <FormGroup>
              <FormControlLabel
                control={
                  <Checkbox
                    className='check-box'
                    checked={!!initialValue?.forChild?.value}
                    onChange={() =>
                      handleOnChange({
                        forChild: {
                          ...initialValue?.forChild,
                          value: !initialValue?.forChild?.value,
                          errors: {},
                        },
                      })
                    }
                  />
                }
                label='For Child'
              />
            </FormGroup>
          </div>
        </div>
        <div className='col-md-12'>
          <div className='row'>
            <div className='col-md-6 mb-3'>
              <CustomTextField
                type='number'
                item={{
                  ...initialValue.minAge,
                  value:
                    initialValue?.minAge?.value === '' ? undefined : initialValue?.minAge?.value,
                }}
                handleInputChange={(e) =>
                  handleOnChange({
                    minAge: { ...initialValue.minAge, value: e?.value ?? '' },
                  })
                }
                min={1}
                step={1}
              />
            </div>
            <div className='col-md-6 mb-3'>
              <div className='d-flex align-items-center'>
                <div className='flex-grow-1'>
                  <CustomMultiSelect
                    item={{
                      ...initialValue?.gender,
                      value: toIds(initialValue?.gender?.value),
                      fieldName: initialValue?.gender?.fieldName || 'Gender',
                    }}
                    options={GENDER_OPTIONS}
                    labelField='name'
                    valueField='id'
                    placeholder='Gender'
                    classNameProps='ellipsisText'
                    showFooterClearInMenu
                    clearAllText='Clear'
                    hideNullOption
                    handleInputChange={(selectedField) => {
                      handleOnChange({
                        gender: { ...initialValue?.gender, value: selectedField.value, errors: {} },
                      });
                    }}
                  />
                  <div style={{ height: 10 }} />
                </div>
                <CustomToolTip
                  title='Applicable if the activity is gender specific'
                  placement='right-end'
                >
                  <span className='ms-2 mt-3 info-pointer'>
                    <InfoIcon fontSize='small' />
                  </span>
                </CustomToolTip>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='row my-3'>
        <h4 className='tab-title'>Availability</h4>
        <div className='d-flex justify-content-between'>
          <FormControl>
            <RadioGroup
              row
              name='availability'
              value={initialValue?.availability?.value}
              onChange={(e) => {
                const newValue = e?.target?.value;
                handleOnChange({
                  availability: {
                    ...initialValue.availability,
                    value: newValue,
                    errors: {},
                  },
                });
              }}
            >
              <FormControlLabel
                value='residentsOnly'
                control={<Radio className='radio' />}
                label='Residents Only'
                className='me-5'
              />
              <FormControlLabel value='openToAll' control={<Radio />} label='Open to all' />
            </RadioGroup>
          </FormControl>
        </div>
      </div>

      <div className='row'>
        <div className='col-md-12 mb-3'>
          <KeyValuePairList
            item={initialValue.customAttributes}
            onListChange={(e) => {
              handleOnChange({ customAttributes: e });
            }}
          />
        </div>
      </div>
    </>
  );
};

export default Details;
